import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc1a4148"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Indietro", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "content"
}
const _hoisted_10 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_11 = { class: "title text-input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Nome Evento", -1))
const _hoisted_13 = {
  key: 0,
  class: "font-light text-error-800"
}
const _hoisted_14 = { class: "address text-input" }
const _hoisted_15 = { for: "address" }
const _hoisted_16 = { class: "date text-input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start-date" }, "Data inizio", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "font-light text-error-800"
}
const _hoisted_20 = { class: "date text-input" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "Data fine", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_24 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_25 = { class: "description text-input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Contenuto Evento", -1))
const _hoisted_27 = {
  key: 1,
  class: "content overflow-hidden"
}
const _hoisted_28 = { class: "global-event-section items-end" }
const _hoisted_29 = { class: "is-global text-input pb-4 py-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is-special" }, "Evento Globale", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global-event-description pb-4 pl-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Se settato come \"Globale\", questo evento sarà visualizzabile da tutti gli utenti."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("In caso contrario sarà visualizzabile solamente agli utenti selezionati")
  ])
], -1))
const _hoisted_32 = { class: "left-content" }
const _hoisted_33 = { class: "searchbar flex" }
const _hoisted_34 = { class: "user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_35 = { class: "working-site-title font-bold" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "right-content" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-description-voices grid grid-cols-2 gap-4 py-3 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "pl-3" }, "Dipendente"),
  /*#__PURE__*/_createElementVNode("div", { class: "delete" })
], -1))
const _hoisted_39 = { class: "added-user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_40 = { class: "working-site-title font-bold" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 2,
  class: "content"
}
const _hoisted_43 = { class: "content-success text-center m-auto items-center mt-20" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-bold" }, [
  /*#__PURE__*/_createTextVNode("La modifica dell'evento è avvenuta"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("con successo!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_SuccessIcon = _resolveComponent("SuccessIcon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, { class: "add-new-working-site-modal-dialog" }, {
    h4: _withCtx(() => [
      (_ctx.isShowingStep2)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "go-back flex absolute",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideStepTwoDialog()))
          }, [
            _createVNode(_component_LeftArrow),
            _hoisted_1
          ]))
        : _createCommentVNode("", true)
    ]),
    h1: _withCtx(() => [
      (_ctx.hideDelete)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.isEditing ? 'Stai modificando l\'evento' : 'Stai aggiungendo un nuovo evento'), 1))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.isEditing ? 'Aggiornamento Evento completata' : 'Creazione Evento completata'), 1))
        : _createCommentVNode("", true)
    ]),
    h2: _withCtx(() => [
      (_ctx.isShowingStep1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.isEditing ? 'Modifica le seguenti informazioni' : 'Aggiungi le seguenti informazioni'), 1))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Aggiungi dipendenti all'evento"))
        : _createCommentVNode("", true)
    ]),
    h3: _withCtx(() => [
      (_ctx.isShowingStep1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Step 1 di 2"))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Step 2 di 2"))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.isEditing ? 'Modifica Evento' : 'Creazione Evento'), 1))
        : _createCommentVNode("", true)
    ]),
    buttons: _withCtx(() => [
      (_ctx.hideDelete)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 0,
            class: "button bg-white text-primary-800 undo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep1)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 1,
            class: "button bg-primary-800 text-white",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showStepTwoDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Avanti")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep2 && _ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 2,
            class: "button bg-primary-800 text-white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aggiorna")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep2 && !_ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 3,
            class: "button bg-primary-800 text-white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.create()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Crea")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep3)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 4,
            class: "button bg-primary-800 text-white m-auto text-center",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateToWorkingSite()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Vai al calendario")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.isShowingStep1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-primary-50 border-error-800", { border: _ctx.v$.step1.title.$error }]),
                  id: "title",
                  type: "text",
                  placeholder: "Inserisci il nome dell'evento",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.title) = $event)),
                  onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.title.$touch && _ctx.v$.step1.title.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.step1.title]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.title.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_13, "È necessario inserire il nome dell'evento."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _createTextVNode("Indirizzo dell'evento"),
                  _createVNode(_component_GMapAutocomplete, {
                    class: _normalizeClass(["bg-primary-50", { 'placeholder-as-text': _ctx.wsaPlaceholderIsAddress }]),
                    id: "address",
                    placeholder: _ctx.workingSiteAddressPlaceholder,
                    onPlace_changed: _ctx.onGmapAutocompleteAddress
                  }, null, 8, ["placeholder", "onPlace_changed", "class"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "hidden",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.address) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.step1.address]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.step1.startDate,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.step1.startDate) = $event)),
                  mode: "dateTime",
                  "input-debounce": 500,
                  is24hr: true
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createElementVNode("input", _mergeProps({
                      class: "bg-primary-50 border-red-400",
                      id: "start-date",
                      type: "text",
                      placeholder: "GG/MM/AAAA HH:mm",
                      value: inputValue
                    }, _toHandlers(inputEvents, true), {
                      class: { border: _ctx.v$.step1.startDate.$error },
                      onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.startDate.$touch && _ctx.v$.step1.startDate.$touch(...args)))
                    }), null, 16, _hoisted_18)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.startDate.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_19, "È necessario inserire la data di inizio cantiere"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.step1.endDate,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.step1.endDate) = $event)),
                  mode: "dateTime",
                  "input-debounce": 500,
                  is24hr: true
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createElementVNode("input", _mergeProps({
                      class: "bg-primary-50 border-red-400",
                      id: "start-date",
                      type: "text",
                      placeholder: "GG/MM/AAAA HH:mm",
                      value: inputValue
                    }, _toHandlers(inputEvents, true), {
                      class: { border: _ctx.v$.step1.endDate.$error },
                      onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.endDate.$touch && _ctx.v$.step1.endDate.$touch(...args)))
                    }), null, 16, _hoisted_22)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.endDate.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_23, "È necessario inserire la data di fine evento"))
                      : _createCommentVNode("", true),
                    (error.$validator == 'dateValidator')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_24, "La data inserita non è valida"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.endDate.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("textarea", {
                  class: _normalizeClass(["bg-primary-50 col-span-2 p-6 pt-4", { border: _ctx.v$.step1.description.$error }]),
                  id: "description",
                  rows: "5",
                  placeholder: "Inserisci la descrizione dell'evento",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.step1.description) = $event)),
                  onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.title.$touch && _ctx.v$.step1.title.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.step1.description]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_Toggle, {
                  class: "inline-block self-center",
                  id: "is-special",
                  modelValue: _ctx.step2.isGlobal,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.step2.isGlobal) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_30
              ]),
              _hoisted_31
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid-cols-2 gap-4", { disabled: _ctx.step2.isGlobal }])
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["text px-4 py-3 flex-grow user-filter-input", { disabled: _ctx.step2.isGlobal }]),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.usersSearchFilter) = $event)),
                    type: "text",
                    placeholder: "Inserisci il nome del dipendente"
                  }, null, 2), [
                    [_vModelText, _ctx.usersSearchFilter]
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button text-primary flex-none font-bold find", { disabled: _ctx.step2.isGlobal }]),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.searchUsers()))
                  }, "Cerca", 2)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unselectedUsers, (unselectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user",
                      key: unselectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(unselectedUser.name) + " " + _toDisplayString(unselectedUser.surname), 1),
                      _createElementVNode("button", {
                        class: "add-working-site font-bold",
                        onClick: ($event: any) => (_ctx.addUser(unselectedUser.id))
                      }, "Aggiungi", 8, _hoisted_36)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (selectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user grid grid-cols-3",
                      key: selectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(selectedUser.name) + " " + _toDisplayString(selectedUser.surname), 1),
                      _createElementVNode("button", {
                        class: "remove-user font-bold",
                        onClick: ($event: any) => (_ctx.removeUser(selectedUser.id))
                      }, "Elimina", 8, _hoisted_41)
                    ]))
                  }), 128))
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowingStep3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_SuccessIcon, { class: "mx-auto mb-12" }),
              _hoisted_44
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 3,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}